import React, { useCallback, useState } from 'react';

import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import ContactSupport from '../../../common/Labels/ContactSupportLink';
import Label from '../../../common/Labels/Label';

import SelectablePipelineHistoryList from './SelectablePipelineHistoryList';
import useListPipelineVersions from '../hooks/useListPipelineVersions';

const AdminPipelineHistorySection = ({
  error, versions, selectedVersions, setSelectedVersions
}) => (
  <div className="flex flex-col h-64">
    <div className="w-filter-modal flex flex-col overflow-scroll">
      <SelectablePipelineHistoryList 
        values={versions}
        selectedValues={selectedVersions}
        setSelectedValues={setSelectedVersions}
      />
    </div>
    {
      error && (
        <div className="p-2 h-full flex flex-col-reverse justify-start self-center">
          <Label color="error" size="sm">
              Error while deleting the selected version(s). Please try again or <ContactSupport>contact support</ContactSupport> if the issue persists.
          </Label>
        </div>
      )
    }
  </div>
)

export const AdminPipelineHistoryModal = ({
  row,
  // error = null,
  onVersionsSelected = () => {},
  showDialog = false,
  onDialogToggle = () => {},
}) => {
  const [selectedVersions, setSelectedVersions] = useState([]);
  const pipelineId = row?.original?.name;
  const workspaceId = row?.original?.workspace?.workspace_id;
  const { data, isLoading, error } = useListPipelineVersions(pipelineId, workspaceId);

  const onConfirm = useCallback(() => {
    onVersionsSelected(selectedVersions, pipelineId, workspaceId);
  }, [onVersionsSelected, pipelineId, selectedVersions, workspaceId])

  const disableConfirm = !selectedVersions?.length;
  return (
    <ConfirmationDialog
      title="Manage Versions"
      confirmButtonText="Delete Selected"
      confirmButtonType="danger"
      modalAnimationKey="manage-pipeline-versions-modal"
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      onConfirm={onConfirm}
      disableConfirmationButton={disableConfirm}
    >
      <AdminPipelineHistorySection
        error={error}
        versions={data ?? []}
        selectedVersions={selectedVersions}
        setSelectedVersions={setSelectedVersions}
      />
    </ConfirmationDialog>
  )
};

export default AdminPipelineHistoryModal;
